import { MessageProps } from './Message';

export default function NoAudio(props: MessageProps & { noText?: boolean }) {
  return (
    <g transform={`translate(1.5,${props.parentHeight / 2})`}>
      <rect width={props.parentWidth} height={2} fill={'rgb(240 0 0)'} />
      {/* <g transform={`translate(-0.5,${props.parentHeight / 2})`}> */}
      {/* <Message fill="rgba(255, 0, 0, 0.5)" {...props}>
          ⚠{!props.noText && <React.Fragment> No audio</React.Fragment>}
        </Message> */}
      {/* </g> */}
    </g>
  );
}
